<!-- eslint-disable -->
<header class="app-header">
  <div class="header-left">
    <button class="toggle-btn" (click)="sidebarService.toggle()">
      <svg lucideMenu></svg>
    </button>
    <div class="header-titles">
      <div class="header-title-main">
        Welcome,
        <span class="header-user">{{ displayName }}</span>
      </div>
      <div class="header-title-sub">Insurance Accounting &amp; MGA Financial Operations</div>
    </div>
  </div>
  <div class="header-right">
    <div
      class="user-menu"
      (click)="toggleDropdown()"
      (keydown.enter)="toggleDropdown()"
      (keydown.space)="toggleDropdown(); $event.preventDefault()"
    >
      <div class="user-avatar" [style.background]="avatarColor">
        {{ initials }}
      </div>
      <span class="user-name">{{ displayName }}</span>
      <svg lucideChevronDown class="chevron"></svg>
      @if (dropdownOpen) {
        <div class="user-dropdown">
          <div class="dropdown-user-info">
            <div class="dropdown-name">{{ displayName }}</div>
            <div class="dropdown-email">{{ userEmail }}</div>
          </div>
          <div class="dropdown-divider"></div>
          <button class="dropdown-item dropdown-item-danger" (click)="signOut($event)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Sign Out
          </button>
        </div>
      }
    </div>
  </div>
</header>
